import React, { Component } from "react";
import { COLORS } from "../../helpers/ant-novak/helpers";

function convertPolynomPoints(arrayPts) {
  return arrayPts
    .map(function (point) {
      return point[0] + "," + point[1];
    })
    .join(" ");
}

class PassiveRadiatorSVG extends Component {
  render() {
    // List of inputs ("props") :
    //        Rmult ... Rloss = Rmult * Rms
    //        fmult ... fb = fmult * fs
    const BOX = { x: 0, y: 10, w: 100, h: 120 };
    const HP1 = { x: 0, y: 20, w: 30, h: 30, l: 30 };
    const HP2 = { x: 100, y: 50, w: 30, h: 30, l: 30 };

    const LINE_STYLE = { fill: "white", stroke: "black", strokeWidth: 2 };
    const LINE_STYLE_ORANGE = { fill: "white", stroke: COLORS[0], strokeWidth: 2 };

    return (
      <svg viewBox="0 0 120 140">
        {/*-- BOX --*/}
        <rect
          x={BOX.x}
          y={BOX.y}
          width={BOX.w}
          height={BOX.h}
          style={{ fill: "white", strokeWidth: 2, stroke: "black" }}
        />
        {/*-- HP1 --*/}
        <polygon points={createSpeaker(HP1, 1, true)} style={LINE_STYLE_ORANGE} />
        {/*-- HP2 --*/}
        <polygon points={createSpeaker(HP2, -1, false)} style={LINE_STYLE_ORANGE} />
      </svg>
    );
  }
}
export default PassiveRadiatorSVG;

function createSpeaker(HP, dir, motor) {
  const PTS = [
    [HP.x + (dir * HP.w) / 2, HP.y + HP.l / 2],
    [HP.x + (dir * HP.w) / 2, HP.y + HP.l / 2 + HP.h],
    [HP.x, HP.y + HP.l + HP.h],
    [HP.x, HP.y],
    [HP.x + (dir * HP.w) / 2, HP.y + HP.l / 2],
  ];

  if (motor) {
    PTS.push(
      [HP.x + dir * HP.w, HP.y + HP.l / 2],
      [HP.x + dir * HP.w, HP.y + HP.l / 2 + HP.h],
      [HP.x + (dir * HP.w) / 2, HP.y + HP.l / 2 + HP.h]
    );
  }

  return convertPolynomPoints(PTS);
}
